/**
 * The three framed counters above the awaiting-review queue.
 *
 * THEY SURVIVED THE SCREEN THEY WERE BUILT FOR. The auto-approval table went
 * away because it listed the same offers as the queue below it; these three
 * numbers are the opposite — nothing in a queue of UNRESOLVED offers can tell
 * you how many the policy approved on its own today, how many it held, or how
 * often somebody overruled it, because every one of those counts over offers
 * that have already left the queue. So the strip moved here and the table did
 * not.
 *
 * Each one carries a CONTEXT LINE, and the context line is the whole reason
 * they are cards rather than the thin count strip they replaced. "19" is not
 * a fact anybody can act on; "19 of 34 scored" is, and "4 margin below floor ·
 * 9 demand unknown" tells somebody which rule to go and argue with.
 *
 * Every figure comes from the summary endpoint through `decisionFacts`. The
 * three places a plausible wrong number could appear are each handled as an
 * absence instead:
 *
 *   share === null       nothing was scored. The line says so rather than
 *                        rendering "0%", which is a claim about the policy.
 *   held breakdown []    no held rows, so no breakdown line at all.
 *   disagreements null   the overrides request failed. "Could not be counted"
 *                        — never 0, which would read as perfect agreement.
 */

import React from 'react';

const asPct = (share) => `${Math.round(share * 100)}%`;

function CounterCards({
  totals, held, disagreements, period,
}) {
  return (
    <div className="auto-approval-counters">
      <div className="auto-approval-counter">
        <div className="auto-approval-counter-label">Auto-approved</div>
        <div className="auto-approval-counter-value is-good">{totals.approved}</div>
        <div className="auto-approval-counter-note">
          {totals.share === null
            ? `nothing scored in the ${period}`
            : `of ${totals.scored} scored · ${asPct(totals.share)} · ${period}`}
        </div>
      </div>

      <div className="auto-approval-counter">
        <div className="auto-approval-counter-label">Held for a person</div>
        <div className="auto-approval-counter-value is-held">{totals.held}</div>
        <div className="auto-approval-counter-note">
          {held.length === 0
            ? `nothing held in the ${period}`
            : held.map((entry, index) => (
              <span key={entry.reason} title={entry.copy}>
                {index > 0 ? ' · ' : ''}
                {`${entry.count} ${entry.label}`}
              </span>
            ))}
        </div>
      </div>

      <div className="auto-approval-counter">
        <div className="auto-approval-counter-label">Policy disagreements</div>
        <div className="auto-approval-counter-value">
          {disagreements === null ? '—' : disagreements}
        </div>
        <div className="auto-approval-counter-note">
          {disagreements === null
            ? 'could not be counted just now'
            : 'people overriding the agent, last 30 days'}
        </div>
      </div>
    </div>
  );
}

export default CounterCards;
